import './FreelanceListFilters.scss'

import {Component} from "react"
import {Input} from "reactstrap"
import {Trash, X} from "react-feather"
import PropTypes from "prop-types"
import { isEqual } from '../../../../services/lodashInJS.js'

import {comparison, FIELD_TYPES} from "../../constant.js"
import CardCol from "../../../Styled/Card/CardCol.jsx"
import CardRow from "../../../Styled/Card/CardRow.jsx"

class FreelanceListFilters extends Component {
  constructor(props) {
    super(props)
    this.state = {
      filters : this.initializeFiltersData(),
      defaultValues: undefined,
      isMounted: false,
    }
  }

  componentDidMount() {
    this.setState( {
      filters : this.initializeFiltersData(),
      isMounted: true,
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {state: currentState, props: currentProps} = this

    if(!isEqual(currentProps.defaultValues, prevProps.defaultValues)) {
      this.setState( {
        filters : this.initializeFiltersData()
      })
      return
    }
    if(
      (currentProps.defaultValues && Object.keys(currentProps.defaultValues).length)
      && (!currentState.filters || !currentState.filters.length)
      && !currentState.defaultValues
    ) {
      this.setState( {
        filters : this.initializeFiltersData()
      })
    }
  }

  initializeFiltersData = () => {
    const {defaultValues} = this.props

    const initializeSearchFilters = []
    if(defaultValues) {
      Object.keys(defaultValues)
        .forEach((defaultValueKey) => {
          const value = defaultValues[defaultValueKey].value
          if(typeof value === 'object') {
            Object.keys(value)
              .forEach((subKey) => {
                initializeSearchFilters.push( {
                  field: defaultValueKey,
                  value: defaultValues[defaultValueKey].value[subKey],
                  comparison: subKey
                })
              })
            return
          }
          initializeSearchFilters.push( {
            field: defaultValueKey,
            value: defaultValues[defaultValueKey].value
          })
        })
    }

    return initializeSearchFilters
  }

  onFilterValueChange = (event, filter, comparisonSymbol = undefined ) => {
    const {
      filters
    } = this.state

    const value = event.currentTarget.value

    const foundIndex = filters.findIndex((searchFilter) => {
      if(comparisonSymbol) {
        return searchFilter.field === filter.filterKey && searchFilter.comparison === comparisonSymbol
      }
      return searchFilter.field === filter.filterKey
    })

    if(foundIndex >= 0) {
      filters.splice(foundIndex, 1)
    }

    if (comparisonSymbol && value === "") {
      this.setState({ filters: [...filters] })
      return
    }

    const data = {
      field: filter.filterKey,
      value: value,
    }

    if (comparisonSymbol) {
      if (!value || value === '') {
        this.setState({
          filters: [
            ...filters,
          ]
        })
        return
      }
      data['comparison'] = comparisonSymbol
    }

    this.setState({
      filters: [
        ...filters,
        data,
      ]
    })
  }

  render() {
    const {
      checkedFilters,
      choices,
      defaultValues: propsDefaultValues,
      onDeleteFilter,
      onDeleteAllFilters,
      onSubmit
    } = this.props

    const {
      defaultValues: stateDefaultValues,
      filters,
      isMounted,
    } = this.state

    const {
      onFilterValueChange,
    } = this

    if(!isMounted) {
      return null
    }

    if (checkedFilters.length <= 0) {
      return null
    }

    const defaultValues = (propsDefaultValues)
      ? propsDefaultValues
      : stateDefaultValues

    return(
      <CardRow className="freelance-list-active-filters" justify="space-between">
        <CardCol flex={1}>
          {checkedFilters.map((checkedFilter, index) => {
            const filterDefaultValue = defaultValues[checkedFilter.filterKey]?.value
            return (
              <CardRow
                className="freelance-list-active-filters-row"
                key={`active-filter-${index}`}
                direction="column"
                gap="0.2rem"
                p="0 0 0.5rem 0"
                justify="space-between">
                <CardCol className="freelance-list-active-filters-form-col">
                  <CardRow gap={'0.3rem'} align="center" justify="center">
                    <CardCol className={'filter-label'}>
                      {checkedFilter.label}
                    </CardCol>

                    <CardCol flex={1} className={'filter-input'}>
                      {(checkedFilter.type === FIELD_TYPES.STRING || checkedFilter.type === FIELD_TYPES.NUMBER) && (
                        <Input
                          type={(checkedFilter.type === FIELD_TYPES.NUMBER)? "number": "text"}
                          defaultValue={filterDefaultValue}
                          name={`input-filter-${checkedFilter.filterKey}`}
                          onChange={(event) => onFilterValueChange(event, checkedFilter)}/>
                      )}

                      {(checkedFilter.type === FIELD_TYPES.DATE) && (
                        <CardRow className="dates-filter-type-row" justify="space-between">
                          <CardCol style={{textAlign: 'center'}}>
                            A partir du <i>(inclus)</i>
                            <Input
                              type="date"
                              defaultValue={filterDefaultValue?.[comparison.GREATER_EQUAL.value] ?? null}
                              name={`input-filter-${checkedFilter.filterKey}`}
                              onChange={(event) => onFilterValueChange(event, checkedFilter, comparison.GREATER_EQUAL.value)}/>
                          </CardCol>

                          <CardCol style={{textAlign: 'center'}}>
                            Jusqu'au <i>(inclus)</i>
                            <Input
                              type="date"
                              defaultValue={filterDefaultValue?.[comparison.LESSER_EQUAL.value] ?? null}
                              name={`input-filter-${checkedFilter.filterKey}`}
                              onChange={(event) => onFilterValueChange(event, checkedFilter, comparison.LESSER_EQUAL.value)}/>
                          </CardCol>
                        </CardRow>
                      )}

                      {(checkedFilter.type === FIELD_TYPES.BOOLEAN) && (
                        <Input
                          type="select"
                          name={`select-filter-${checkedFilter.filterKey}`}
                          onChange={(event) => onFilterValueChange(event, checkedFilter)}
                          value={filters.find(f => f.field === checkedFilter.filterKey)?.value ?? ""}
                        >
                          <option value={0}> Non </option>
                          <option value={1}> Oui </option>
                        </Input>
                      )}

                      {(checkedFilter.type === FIELD_TYPES.OBJECT) && (
                        <Input type="select"
                          name={`select-filter-${checkedFilter.filterKey}`}
                          onChange={(event) => onFilterValueChange(event, checkedFilter)}
                          value={filters.find(f => f.field === checkedFilter.filterKey)?.value ?? ""}
                        >
                          <option value={""}>Aucun</option>
                          {
                            choices[checkedFilter.choiceKey]
                              .map((choice, index) => {
                                const value = choice[checkedFilter.choiceValueKey]
                                const label = choice[checkedFilter.choiceLabelKey]
                                return (
                                  <option key={`choice-${index}`} value={value}>
                                    {label}
                                  </option>
                                )
                              })
                          }
                        </Input>
                      )}
                    </CardCol>

                    {Object.values(FIELD_TYPES).includes(checkedFilter.type)
                      ? <CardCol className={'filter-delete'}>
                        <div className={'delete-filters'} onClick={() => onDeleteFilter(checkedFilter)}>
                          <X size={24}/>
                        </div>
                      </CardCol>
                      : null
                    }
                  </CardRow>
                </CardCol>
              </CardRow>
            )
          })}
        </CardCol>

        <CardCol className="freelance-list-active-filters-actions">
          <CardRow gap="1rem">
            <CardCol>
              <button type="button" className="btn btn-primary" onClick={() => onSubmit(filters)}>
                Filtrer
              </button>
            </CardCol>
            <CardCol>
              <button type="button" className="btn btn-danger" onClick={onDeleteAllFilters}>
                <Trash size={30}/>
              </button>
            </CardCol>
          </CardRow>
        </CardCol>
      </CardRow>
    )
  }
}

FreelanceListFilters.propTypes = {
  checkedFilters: PropTypes.array.isRequired,
  choices: PropTypes.object.isRequired,
  defaultValues: PropTypes.object.isRequired,
  onDeleteFilter: PropTypes.func.isRequired,
  onDeleteAllFilters: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default FreelanceListFilters
